import { useModalStore } from "@/stores/modalStore";
import PostModal from "@/components/Post/PostModal.vue";
import { getPost } from "@/api/axios.js";
import { useRouter } from "vue-router";
import { useAuthStore } from "../stores/authStore";

export function useOpenPost(posts) {
  const modalStore = useModalStore();
  const router = useRouter();
  const auth = useAuthStore();

  async function openPost(id, options = {}) {
    let post = posts?.find((p) => p.id === Number(id));

    if (!post) {
      try {
        const res = await getPost(id);
        post = res.data;
      } catch (e) {
        console.error("Error fetching post:", e);
        return;
      }
    }

    const route = router.currentRoute.value;

    if (route.name === "Feed") {
      router.push({ name: "Post", params: { id } });
    } else if (route.name === "Profile" || route.name === "UserProfile") {
      router.push({
        name: "ProfilePost",
        params: { id: route.params.id || auth.user.id, postId: id },
      });
    }

    modalStore.openModal({
      component: PostModal,
      props: { post, isModal: true, commentVisible: !!options.showComments },
      options: { lockScroll: true },
      onClose: () => router.back(),
    });
  }

  return { openPost };
}
